import ApiBase from 'Services/Api/ApiBase';

class Timesheets extends ApiBase {
    route = '/human-resources/timesheets';
};

export default new Timesheets();